export const mainHomeVisao = [

  {
    id: 0,
    titulo: "Missão",
    texto: "Impulsionamos a inclusão social por meio da conexão com projetos inovadores de educação transformadora.",
    imagem: 'https://somosconexaosocial.org/site_img/main_home/02.jpg'

  },
  {
    id: 1,
    titulo: "Visão",
    texto: "Em 2030, a Conexão Social é referência no Brasil pelo seu trabalho de inclusão social e seu compromisso com a promoção de práticas sustentáveis e soluções inovadoras.",
    imagem: 'https://somosconexaosocial.org/site_img/main_home/03.jpg'

  },
  {
    id: 2,
    titulo: "Valores",
    texto: "Acolhimentoe Qualidade nos Serviços; Aprendizadoe Desenvolvimento; Compromissoe Resiliência; Conexão Social e Trabalho em Rede; Empatia e Cuidado; Ética e Transparência; Inclusão e Participação; Inovação e Adaptabilidade; Respeito e Diversidade; Responsabilidade Social e Ambiental; Senso de Justiça e Colaboração; Solidariedade e Comunidade.",
    imagem: 'https://somosconexaosocial.org/site_img/main_home/04.jpg'

  },

]

